export const removeEmptyParams = <T>(params: T): T => {
    return Object.fromEntries(
        Object.entries(params).filter(
            ([_key, value]) => value || value === false
        )
    ) as T;
};
